import { render } from "./ControlloConsumi.vue?vue&type=template&id=61f11bac"
import script from "./ControlloConsumi.vue?vue&type=script&lang=js"
export * from "./ControlloConsumi.vue?vue&type=script&lang=js"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__